import { useEffect, useState } from 'react';

export function useCountdown(targetIso: string | null | undefined): { mmss: string; expired: boolean; secondsLeft: number } {
  const target = targetIso ? new Date(targetIso).getTime() : 0;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return { mmss: '--:--', expired: false, secondsLeft: 0 };
  const secondsLeft = Math.max(0, Math.floor((target - now) / 1000));
  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const ss = String(secondsLeft % 60).padStart(2, '0');
  return { mmss: `${mm}:${ss}`, expired: secondsLeft === 0, secondsLeft };
}
